import { render } from "./Tarieven.vue?vue&type=template&id=1cdcd554&scoped=true&ts=true"
import script from "./Tarieven.vue?vue&type=script&lang=ts"
export * from "./Tarieven.vue?vue&type=script&lang=ts"

import "./Tarieven.vue?vue&type=style&index=0&id=1cdcd554&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdcd554"]])

export default __exports__